import _ from 'lodash/string'
import { mapGetters, } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      default: 'directParent',
      validator: (value) => [
        'directParent',
        'ultimateParent',
        'fundManager',
        'umbrellaFund',
        'masterFund',
        'headOffice',
      ].includes(value),
    },
  },
  computed: {
    ...mapGetters('record', [ 'getParent', 'getParentException', ]),
    hasParentOrException () {
      return !!this.hasParent || !!this.hasException
    },
    hasParent () {
      return !!this.parent
    },
    hasException () {
      return !!this.exception
    },
    article () {
      return this.type === 'directParent' ? 'a' : 'an'
    },
    defaultTitle () {
      return _.startCase(this.type)
    },
    parent () {
      return this.getParent(this.type)
    },
    exception () {
      return this.getParentException(this.type)
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/challenge-parent.js